import { useState } from 'react';

export const useLOVForm = () => {
  const [openBackgroundDrawer, setOpenBackgroundDrawer] = useState(false);
  const [openProductsDrawer, setOpenProductsDrawer] = useState(false);
  const [openTitleDrawer, setOpenTitleDrawer] = useState(false);
  const [openSettingsDrawer, setOpenSettingsDrawer] = useState(false);

  const onToggleBackgroundDrawer = () =>
    setOpenBackgroundDrawer(!openBackgroundDrawer);

  const onToggleTitleDrawer = () => setOpenTitleDrawer(!openTitleDrawer);

  const onToggleProductsDrawer = () =>
    setOpenProductsDrawer(!openProductsDrawer);

  const onToggleSettingsDrawer = () =>
    setOpenSettingsDrawer(!openSettingsDrawer);

  return {
    openBackgroundDrawer,
    openProductsDrawer,
    openSettingsDrawer,
    onToggleBackgroundDrawer,
    onToggleProductsDrawer,
    openTitleDrawer,
    onToggleTitleDrawer,
    onToggleSettingsDrawer,
  };
};
